// extracted by mini-css-extract-plugin
module.exports = {"container":"EndArrow_container__3ByfN","line":"EndArrow_line__2C5nj","lineEnd":"EndArrow_lineEnd__qVUhV","arrowHead":"EndArrow_arrowHead__20wiM"};